import dkAxios from '@/jslib/dk-axios'

export const getGroupList = data => dkAxios({
  url: '/cms/Group',
  method: 'GET',
  params: data,
});

export const getAdminLog = data => dkAxios({
  url: '/cms/AdminLog',
  method: 'GET',
  params: data,
});

export const getMenuBar = () => dkAxios({
  url: '/cms/MenuBar',
  method: 'GET',
});

export const getGroupPermissionDetail = data => dkAxios({
  url: '/cms/GroupPermission',
  method: 'GET',
  params: data,
});


export const delGroup = data => dkAxios({
  url: `/cms/Group/${data}`,
  method: 'DELETE',
});


export const addGroup = data => dkAxios({
  url: '/cms/Group',
  method: 'POST',
  data,
});


export const editGroup = data => dkAxios({
  url: `/cms/Group/${data.uuid}`,
  method: 'PUT',
  data,
});


export const getAdminList = data => dkAxios({
  url: '/cms/Admin',
  method: 'GET',
  params: data,
});

export const getAdminDetail = data => dkAxios({
  url: `/cms/Admin/${data}`,
  method: 'GET',
});


export const addAdmin = data => dkAxios({
  url: '/cms/Admin',
  method: 'POST',
  data,
});


export const editAdmin = data => dkAxios({
  url: `/cms/Admin/${data.uuid}`,
  method: 'PUT',
  data,
});


export const deleteAdmin = data => dkAxios({
  url: `/cms/Admin/${data}`,
  method: 'DELETE',
});



// WEBPACK FOOTER //
// ./src/api/system.js